"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichOrderEventWithType = exports.generateDependentEvents = exports.generateOrderEvent = exports.SOURCE_OPTIONS_ATTRS = void 0;
const domain_1 = require("@oolio-group/domain");
const uuid_1 = require("uuid");
exports.SOURCE_OPTIONS_ATTRS = [
    'organizationId',
    'venueId',
    'storeId',
    'triggeredBy',
    'deviceId',
    'source',
];
let currentTimeStamp = 0;
/**
 * Generate event object of type T which extends OrderEvent
 * helps to quickly create an order event by specifying only -
 * properties necessary for the event excluding all props from OrderEvent
 * @param action OrderAction eg: OrderAction.ORDER_INITIATE
 * @param session Session object, throws exception if invalid
 * @param input Props specific to event type
 * @param shouldPersisted optional prop to chose to persist the event to db
 */
function generateOrderEvent(action, sourceOptions, input) {
    if (typeof action !== 'string' || typeof sourceOptions !== 'object') {
        throw new Error('Expected at least two arguments of type OrderAction and SourceOptions');
    }
    if (input && typeof input !== 'object') {
        throw new Error('Expected three arguments of type OrderAction, Session and OrderEvent');
    }
    if (!exports.SOURCE_OPTIONS_ATTRS.filter(attr => attr !== 'triggeredBy').every(attr => sourceOptions[attr] && typeof sourceOptions[attr] !== 'undefined')) {
        throw new Error('Invalid session information');
    }
    let timestamp = new Date().getTime();
    if (timestamp <= currentTimeStamp) {
        timestamp = currentTimeStamp + 1;
    }
    currentTimeStamp = timestamp;
    const event = {
        ...(input || {}),
        action,
        id: (0, uuid_1.v4)(),
        timestamp,
        orderId: (input === null || input === void 0 ? void 0 : input.orderId) || (0, uuid_1.v4)(),
        ...exports.SOURCE_OPTIONS_ATTRS.reduce((acc, attr) => ({ ...acc, [attr]: sourceOptions[attr] }), {}),
    };
    return event;
}
exports.generateOrderEvent = generateOrderEvent;
function generateDependentEvents(event, options) {
    switch (event.action) {
        case domain_1.OrderAction.ORDER_TRANSFER_ITEMS:
            const mapSourceOrdersToIds = options;
            const transferredEvents = event.transferItemsFrom
                .map(transferItemsFrom => {
                const orderInfo = mapSourceOrdersToIds[transferItemsFrom.orderId];
                if (!orderInfo)
                    return null;
                return generateOrderEvent(domain_1.OrderAction.ORDER_TRANSFERRED_ITEMS, {
                    triggeredBy: event.triggeredBy,
                    venueId: event.venueId,
                    storeId: event.storeId,
                    deviceId: event.deviceId,
                    organizationId: event.organizationId,
                    source: event.source || domain_1.App.BACKOFFICE,
                }, {
                    orderId: transferItemsFrom.orderId,
                    previous: orderInfo.prevEventId,
                    transferredItemsFrom: transferItemsFrom,
                    transferredItemsTo: event
                        .transferItemsTo,
                    transferredByName: event
                        .transferredByName,
                });
            })
                .filter(Boolean);
            return transferredEvents;
    }
    return [];
}
exports.generateDependentEvents = generateDependentEvents;
const enrichOrderEventWithType = (events) => {
    const results = events.map(event => ({
        ...event,
        __typename: domain_1.ORDER_EVENT_MAP[event.action],
    }));
    return results;
};
exports.enrichOrderEventWithType = enrichOrderEventWithType;
//# sourceMappingURL=orderEventHelper.js.map